module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "epigraph",
    staticStyle: {
      "margin-top": "3em",
      "text-align": "center"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_c('em', [_vm._v("Plato says: One is not even one, two is one hardly")]), _vm._v(".")])]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_c('p', {
    staticClass: "attribute",
    staticStyle: {
      "margin-top": "0.5em",
      "text-align": "center"
    }
  }, [_c('em', [_vm._v("Theopompus fr. 15K")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-499fc7ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780226670393_06_epi.vue
// module id = 69
// module chunks = 0